import { PlusIcon } from 'lucide-react';
import * as React from 'react';
import DraftIcon from '../../../assets/icons/draft-icon.tsx';
import { Button } from '../../../components/ui/button.tsx';
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger,
} from '../../../components/ui/dropdown-menu.tsx';
import { useLocale } from '../../../lib/hooks/use-locale.ts';
import { useAppConfig } from '../../acl/acl-provider.tsx';
import { DialogStateManager } from '../../dialog/dialog-provider.tsx';
import { DropdownMenuItemCreateEvent } from '../../events/components/dropdown-menu-item-create-event.tsx';
import { DropdownMenuItemCreateNote } from '../../notes/components/dropdown-menu-item-create-note.tsx';
import { DraftOrderCreateDialog } from '../../sales-draft-new/views/create-draft-order-dialog.tsx';
import { DropdownMenuItemCreateTask } from '../../tasks/components/dropdown-menu-item-create-task.tsx';

export type CreateNewOrderMenuProps = {
    showFullInput?: boolean;
    className?: string;
    onClose?: () => void;
} & React.InputHTMLAttributes<HTMLInputElement>;

const CreateNewMenu = ({ showFullInput = true }: CreateNewOrderMenuProps): React.ReactNode => {
    const { t } = useLocale();
    const { transactionDraftAvailability } = useAppConfig();
    const [open, setOpen] = React.useState(false);

    const { showSidebarCreateNewButton } = useAppConfig();
    if (!showSidebarCreateNewButton) {
        return null;
    }

    return (
        <DropdownMenu open={open} onOpenChange={setOpen}>
            <DropdownMenuTrigger asChild>
                {showFullInput ? (
                    <Button
                        className="w-full justify-start"
                        variant="ghost"
                        selected={open}
                        onClick={() => {
                            setOpen(true);
                        }}
                        leftIcon={PlusIcon}
                    >
                        <span>{t('top_navbar__new_actvity')}</span>
                    </Button>
                ) : (
                    <Button
                        size="icon-s"
                        variant="outline"
                        selected={open}
                        onClick={() => {
                            setOpen(true);
                        }}
                    >
                        <PlusIcon className="flex h-4 w-4 shrink-0 " />
                    </Button>
                )}
            </DropdownMenuTrigger>
            <DropdownMenuContent align="start" side="right" className="z-9999">
                <DropdownMenuItemCreateTask links={[]} source="navigation_menu" />
                {transactionDraftAvailability !== 'UNAVAILABLE' && (
                    <DropdownMenuItem
                        onSelect={() => {
                            void DialogStateManager.show(DraftOrderCreateDialog, {
                                source: 'navigation_menu',
                            });
                        }}
                    >
                        <DraftIcon className="h-4 w-4" />
                        <span>{t('top_navbar__new_draft')}</span>
                    </DropdownMenuItem>
                )}
                <DropdownMenuItemCreateEvent analyticsSource="menu" />
                <DropdownMenuItemCreateNote analyticsSource="side_menu" />
            </DropdownMenuContent>
        </DropdownMenu>
    );
};

export { CreateNewMenu };
